import { render, staticRenderFns } from "./ThePriceSlider.vue?vue&type=template&id=296f20f0&"
import script from "./ThePriceSlider.vue?vue&type=script&lang=js&"
export * from "./ThePriceSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports